import React, { useState } from "react";
import { useForm, Edit } from "@refinedev/antd";
import dayjs from 'dayjs';
import { ProcurementPlanForm } from "./components/ProcurementPlanForm";
import { PROCUREMENT_PLAN_ONE_QUERY, PROCUREMENT_PLAN_UPDATE_MUTATION } from "./queries";
import { omit } from "lodash";


export const EditProcurementPlan: React.FC = () => {
  const { formProps, saveButtonProps} = useForm<IProcurementPlan>({
    resource: "procurementPlans",
    meta: {
      gqlMutation: PROCUREMENT_PLAN_UPDATE_MUTATION,
      gqlQuery: PROCUREMENT_PLAN_ONE_QUERY,
    },
    action: "edit",
  });
  
  const [items, setItems] = useState<IProcurementItem[]>([]);

  // Handle form submission for approval
  const handleSubmit = async (values: any) => {
    // For edit, we just save the form
    formProps.onFinish?.(values);
  };

  // Handle saving draft (only validate main form fields)
  const handleSaveDraft = async (values: any) => {
    // For edit, we just save the form
    formProps.onFinish?.(values);
  };

  const handleCancel = () => {
    // Handle cancel action
    console.log('Cancelled');
  };

  //useEffect to set items from initial values if available
  React.useEffect(() => {
    if (formProps.initialValues?.items) {
      setItems(formProps.initialValues.items.map((item: IProcurementItem) => ({
        ...omit(item, 'id'), // Exclude createdAt and updatedAt if they exist
        requiredDate: dayjs(item.requiredDate).format('YYYY-MM-DD'),
      })) as IProcurementItem[]);
    }
  }, [formProps.initialValues]);

  return (
    
  
    <Edit
      saveButtonProps={saveButtonProps}
       footerButtons={() => null}
           title="Edit Procurement Plan"
    >
      <ProcurementPlanForm
        form={formProps.form}
        isEdit={true}
        planId={formProps.initialValues?.id}
        initialValues={{
          ...formProps.initialValues,
          submissionDeadline: formProps.initialValues?.submissionDeadline ? dayjs(formProps.initialValues.submissionDeadline) : undefined
        } as any}
        onSaveDraft={handleSaveDraft}
        onSubmitForApproval={handleSubmit}
        onCancel={handleCancel}
        items={items}
        setItems={setItems as any}
        saveButtonProps={saveButtonProps}
      />
    </Edit>
  );
};